import { COOKIE_NAMES } from './enums/cookies';

const findQhUserId = (cookies) => cookies.get(COOKIE_NAMES.QH_USER_ID);

export default findQhUserId;
